import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Invite from "@/components/Invite";
import Events from "@/components/Events";
import Listen from "@/components/Listen";
import Videos from "@/components/Videos";
import Resources from "@/components/Resources";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let lenis = null;
    let frame;
    if (!reduced) {
      lenis = new Lenis({ duration: 1.15, smoothWheel: true });
      const raf = (time) => {
        lenis.raf(time);
        frame = requestAnimationFrame(raf);
      };
      frame = requestAnimationFrame(raf);
    }
    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (!target) return;
      e.preventDefault();
      if (lenis) {
        lenis.scrollTo(target, { offset: -64 });
      } else {
        target.scrollIntoView();
      }
    };
    document.addEventListener("click", onClick);

    // Clean paths: /booking and /testimonials land on those sections
    const pathTarget =
      window.location.pathname === "/booking"
        ? "#invite"
        : window.location.pathname === "/testimonials"
          ? "#testimonials"
          : null;
    if (pathTarget) {
      const timer = setTimeout(() => {
        const el = document.querySelector(pathTarget);
        if (!el) return;
        if (lenis) {
          lenis.scrollTo(el, { offset: -64 });
        } else {
          el.scrollIntoView();
        }
      }, 700);
      return () => {
        clearTimeout(timer);
        if (frame) cancelAnimationFrame(frame);
        if (lenis) lenis.destroy();
        document.removeEventListener("click", onClick);
      };
    }

    return () => {
      if (frame) cancelAnimationFrame(frame);
      if (lenis) lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="App grain" data-testid="app-root">
      <a
        href="#invite"
        data-testid="skip-to-booking-link"
        className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:bg-ink focus:text-paper focus:px-4 focus:py-2 focus:text-sm"
      >
        Skip to booking inquiry
      </a>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Invite />
        <Events />
        <Listen />
        <Videos />
        <Resources />
      </main>
      <Footer />
      <Toaster position="bottom-center" toastOptions={{ style: { background: "#090909", color: "#F4F0E8", border: "1px solid #242424" } }} />
    </div>
  );
}

export default App;
